import React from 'react';
import { motion } from 'framer-motion';
import RadioPlayer from '../components/RadioPlayer';

const Home = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-24 sm:pt-20">
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="hero-circle w-[25rem] h-[25rem] sm:w-[500px] sm:h-[500px] top-[10%] left-[5%] opacity-70"></div>
        <div className="hero-circle w-[30rem] h-[30rem] sm:w-[800px] sm:h-[800px] top-[-20%] right-[-20%] opacity-50"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10">
        {/* Hero Section */}
        <section className="relative py-16 sm:py-20 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 text-glow">
              Live Radio <span className="text-cream-400">Experience</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto text-balance">
              Tune in for premium music, insightful talk shows, and curated entertainment. 
              Broadcasting daily with crystal clear sound quality.
            </p>
          </motion.div>
        </section>

        {/* Radio Player Section */}
        <section className="pb-16 sm:pb-20">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <RadioPlayer />
          </motion.div>
        </section>
      </div>
    </div>
  );
};

export default Home;